// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_root_1lyyo_1vl56_1:not(#\\9){background:#fff}.awsui_toolbar_1lyyo_1vl56_5:not(#\\9){height:48px;background:#fff;border-bottom:1px solid #b6bec9}.awsui_notifications_1lyyo_1vl56_11:not(#\\9){padding-block-start:8px;padding-inline:20px 24px}.awsui_content_1lyyo_1vl56_16:not(#\\9){padding-block:12px 40px;padding-inline:20px 24px}.awsui_notifications_1lyyo_1vl56_11+.awsui_content_1lyyo_1vl56_16:not(#\\9){padding-block-start:16px}\n", ""]);
// Exports
module.exports = exports;
